import Bankstatementanalyzer from "../../../jsx/components/Dashboard/BankStatementAnalyzer/bankstatementanalyzer";

const BankStatementAnalyzerWrapper = () => {
  return <Bankstatementanalyzer />;
};

export default constore(BankStatementAnalyzerWrapper);
